import { Injectable } from '@angular/core';
import API, { graphqlOperation } from '@aws-amplify/api';
import {
  DateTimeFilterInput,
  FloatFilterInput,
  IntFilterInput,
  KeyStringFilterInput,
  StringFilterInput,
} from 'app/api/common.api.types';
import { EMPTY, from, Observable } from 'rxjs';
import { concatAll, expand, map, toArray, tap } from 'rxjs/operators';
import { PayrollExtraEntry } from './payroll.extra.api.service';
import { PayrollRuleEntry } from './payroll.rule.api.service';
export interface PayrollFilterInput {
  key: StringFilterInput;
  // entryDate: DateTimeFilterInput;
  charges: FloatFilterInput;
  extra: FloatFilterInput;
  matricule: StringFilterInput;
  month: StringFilterInput;
  name: StringFilterInput;
  others: FloatFilterInput;
  primes: FloatFilterInput;
  raw: FloatFilterInput;
  fullRaw?: FloatFilterInput;
  fullRawCharges?: FloatFilterInput;
  // Adding extra field
  plannedRaw?: FloatFilterInput;
  timeline?: StringFilterInput; // Timeline
}
export interface PayrollEntryByName {
  name: string;
  matricule: string;
  extras: PayrollRuleEntry[];
  analytics?: object;
  items: { timeline: string; fullRawCharges: number }[];
  totalFlux: { [year: string]: number };
}

export interface PayrollEntry {
  // entryDate
  companyId: string;
  key: string;
  matricule?: string;
  name?: string;

  charges?: number | null;
  extra?: number | null;
  month?: Date;
  others?: number | null;
  primes?: number | null;
  raw?: number | null;

  fullRaw?: number | null;
  fullRawCharges?: number | null;
  fullRawChargesRecalculated?: number | null;
  // Adding extra field
  plannedRaw?: number | null;
  timeline?: string | null; // Timeline
  // Payroll Rule
  extraAxis?: { [key: string]: string | null }; // axe extra
  ana2Axis?: { [key: string]: string | null }; // axe ana2
}

export interface PayrollConnection {
  items: PayrollEntry[];
  lastEvaluatedKey: any;
}

@Injectable({
  providedIn: 'root',
})
export class PayrollAPIService {
  Payroll(
    companyId: string,
    key?: KeyStringFilterInput,
    filter?: PayrollFilterInput,
    limit?: number
  ): Observable<PayrollEntry[]> {
    // tslint:disable-next-line: max-line-length
    const statement = `query Payroll($id: String!, $key: KeyStringFilterInput, $filter: PayrollFilterInput, $limit: Int, $exclusiveStartKey: AWSJSON) {
      company(id: $id) {
        payroll(key: $key, filter: $filter, limit: $limit, exclusiveStartKey: $exclusiveStartKey) {
          items {
            companyId
            key
            charges
            extra
            matricule
            month
            name
            others
            primes
            raw
          }
          lastEvaluatedKey
        }
      }
    }`;
    const gqlAPIServiceArguments: any = {};
    gqlAPIServiceArguments.id = companyId;
    if (key) {
      gqlAPIServiceArguments.key = key;
    }
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }

    return this.performQuery(statement, gqlAPIServiceArguments).pipe(
      expand((conn) => {
        const exclusiveStartKey = conn.lastEvaluatedKey;
        const args = { ...gqlAPIServiceArguments, exclusiveStartKey };
        return conn.lastEvaluatedKey && JSON.parse(conn.lastEvaluatedKey) !== ''
          ? this.performQuery(statement, args)
          : EMPTY;
      }),
      map((conn) => conn.items),
      concatAll(),
      toArray()
    );
  }

  private performQuery(
    statement: string,
    args: any = {}
  ): Observable<PayrollConnection> {
    return from(API.graphql(graphqlOperation(statement, args))).pipe(
      map((response: any) => {
        return response.data.company.payroll as PayrollConnection;
      })
    );
  }
}
